(() => {
  if (customElements.get("fishe-cart-recommendations")) return;

  class FisheCartRecommendations extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest("cart-drawer");
      this.onOpen = () => { void this.load(); };
      this.drawer?.addEventListener("dialog:after-show", this.onOpen);

      if (this.drawer?.open) void this.load();
    }

    disconnectedCallback() {
      this.drawer?.removeEventListener("dialog:after-show", this.onOpen);
      this.abortController?.abort();
    }

    async load() {
      if (this.loaded || this.loading || !this.isConnected) return;

      const productId = Number(this.dataset.productId);
      if (!Number.isSafeInteger(productId) || productId <= 0) return;

      this.loading = true;
      this.abortController = new AbortController();

      try {
        const hasCuratedFallback = Boolean(this.querySelector("[data-fishe-cart-fallback] .horizontal-product-card"));
        const intents = hasCuratedFallback ? ["complementary"] : ["complementary", "related"];

        for (const intent of intents) {
          const root = window.Shopify?.routes?.root || "/";
          const prefix = root.endsWith("/") ? root : root + "/";
          const url = new URL(prefix + "recommendations/products", window.location.origin);
          url.searchParams.set("section_id", "fishe-cart-recommendations");
          url.searchParams.set("product_id", String(productId));
          url.searchParams.set("limit", "4");
          url.searchParams.set("intent", intent);

          const response = await fetch(url.href, {
            credentials: "same-origin",
            signal: this.abortController.signal,
            headers: { Accept: "text/html" }
          });

          if (!response.ok) continue;

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, "text/html");
          const list = documentFragment.querySelector("[data-fishe-cart-dynamic-results]");
          const cards = list?.querySelectorAll(".horizontal-product-card");

          if (list && cards?.length && this.isConnected) {
            const currentList = this.querySelector("[data-fishe-cart-fallback]");
            if (currentList) {
              currentList.replaceWith(document.importNode(list, true));
            } else {
              this.replaceChildren(document.importNode(list, true));
            }
            this.dataset.recommendationIntent = intent;
            break;
          }
        }
      } catch (error) {
        if (error?.name !== "AbortError") {
          this.dataset.recommendationIntent = "curated";
        }
      } finally {
        this.loading = false;
        this.loaded = true;
      }

      if (!this.querySelector(".horizontal-product-card")) {
        const panel = this.closest(".fishe-cart__recommendations");
        if (panel) panel.hidden = true;
      }
    }
  }

  customElements.define("fishe-cart-recommendations", FisheCartRecommendations);
})();
